import React, {FC, ReactNode} from 'react'

import cn from 'classnames/bind'

import s from './Tooltip.module.scss'
const cx = cn.bind(s)

interface ITooltipProps {
	className?: string
	text: string | ReactNode
}

const Tooltip: FC<ITooltipProps> = ({className, text}) => {
	return (
		<span className={cx('wrapper', className)}>
			<button className={cx('btn')} type="button">
				<Icon className={cx('btn__icon')} />
				<span className={cx('btn__text')}>{text}</span>
			</button>
		</span>
	)
}

Tooltip.displayName = 'Tooltip'

export default Tooltip

const Icon: FC<React.SVGProps<SVGSVGElement>> = (props) => (
	<svg
		width="16"
		height="16"
		viewBox="0 0 16 16"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}>
		<g>
			<circle cx="8" cy="8" r="8" />
			<path d="M5.70584 5.056C5.85384 4.932 6.01384 4.816 6.18584 4.708C6.36184 4.6 6.54984 4.506 6.74984 4.426C6.94984 4.342 7.16384 4.278 7.39184 4.234C7.62384 4.186 7.87384 4.162 8.14184 4.162C8.51784 4.162 8.85584 4.212 9.15584 4.312C9.45984 4.412 9.71784 4.556 9.92984 4.744C10.1418 4.928 10.3038 5.152 10.4158 5.416C10.5318 5.676 10.5898 5.966 10.5898 6.286C10.5898 6.59 10.5478 6.854 10.4638 7.078C10.3798 7.298 10.2738 7.49 10.1458 7.654C10.0178 7.818 9.87584 7.96 9.71984 8.08C9.56784 8.2 9.42184 8.312 9.28184 8.416C9.14584 8.516 9.02584 8.616 8.92184 8.716C8.82184 8.816 8.75784 8.928 8.72984 9.052L8.56184 9.892H7.28984L7.15784 8.926C7.12584 8.73 7.14584 8.56 7.21784 8.416C7.28984 8.268 7.38784 8.136 7.51184 8.02C7.63984 7.9 7.78184 7.788 7.93784 7.684C8.09384 7.576 8.23984 7.462 8.37584 7.342C8.51184 7.218 8.62584 7.082 8.71784 6.934C8.81384 6.782 8.86184 6.602 8.86184 6.394C8.86184 6.154 8.78184 5.964 8.62184 5.824C8.46584 5.68 8.24984 5.608 7.97384 5.608C7.76184 5.608 7.58384 5.63 7.43984 5.674C7.29984 5.718 7.17784 5.768 7.07384 5.824C6.97384 5.876 6.88584 5.924 6.80984 5.968C6.73384 6.012 6.65784 6.034 6.58184 6.034C6.40984 6.034 6.28184 5.96 6.19784 5.812L5.70584 5.056ZM6.80984 12.058C6.80984 11.914 6.83584 11.78 6.88784 11.656C6.94384 11.532 7.01784 11.424 7.10984 11.332C7.20584 11.24 7.31784 11.168 7.44584 11.116C7.57384 11.06 7.71384 11.032 7.86584 11.032C8.01384 11.032 8.15184 11.06 8.27984 11.116C8.40784 11.168 8.51984 11.24 8.61584 11.332C8.71184 11.424 8.78584 11.532 8.83784 11.656C8.89384 11.78 8.92184 11.914 8.92184 12.058C8.92184 12.202 8.89384 12.338 8.83784 12.466C8.78584 12.59 8.71184 12.698 8.61584 12.79C8.51984 12.882 8.40784 12.954 8.27984 13.006C8.15184 13.058 8.01384 13.084 7.86584 13.084C7.71384 13.084 7.57384 13.058 7.44584 13.006C7.31784 12.954 7.20584 12.882 7.10984 12.79C7.01784 12.698 6.94384 12.59 6.88784 12.466C6.83584 12.338 6.80984 12.202 6.80984 12.058Z" />
		</g>
	</svg>
)
